import 'telia-front-react/styles/global.css';
import 'telia-front-react/styles/telia.css';
import('./bootstrap');
